export { default } from './StructuredData';
